module.exports = __webpack_public_path__ + "img/collection.c2df66ca.svg";